import { render, staticRenderFns } from "./score_Proportion_tea_new.vue?vue&type=template&id=408ad332&scoped=true&"
import script from "./score_Proportion_tea_new.vue?vue&type=script&lang=js&"
export * from "./score_Proportion_tea_new.vue?vue&type=script&lang=js&"
import style0 from "./score_Proportion_tea_new.vue?vue&type=style&index=0&id=408ad332&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408ad332",
  null
  
)

export default component.exports